import { logger } from '@damofire/data-commons';
import { Remote, wrap } from 'comlink';
import { Observer, Subject } from 'rxjs';
import { WarehouseSyncStepContextEvent, WarehouseSyncStepTask, WarehouseSyncStepTaskContext } from '../executors';
import { WarehouseIssuesMediasStepsWorker } from '../workers/issues-medias.steps.worker';
import { executeWorker, WarehouseSyncStepWorkerFactory } from './steps-utils';

class WarehouseIssuesMediasSyncWorkerFactory implements WarehouseSyncStepWorkerFactory<WarehouseIssuesMediasStepsWorker> {
  async createWorker(environment: any): Promise<[Worker, WarehouseIssuesMediasStepsWorker | Remote<WarehouseIssuesMediasStepsWorker>]> {
    if (environment.appConfig.watson.useWebworkers) {
      const warehouseWorker = new Worker(new URL('../workers/issues-medias.steps.worker', import.meta.url), { type: 'module' });
      const warehouseWorkerProxy = wrap<typeof WarehouseIssuesMediasStepsWorker>(warehouseWorker);
      const workerService = await new warehouseWorkerProxy();
      return [warehouseWorker, workerService];
    }

    return [null, new WarehouseIssuesMediasStepsWorker()];
  }
}

export class WarehouseDownloadIssuesMediasSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `DOWN_ISM_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing download issues-medias sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseIssuesMediasSyncWorkerFactory(), taskBreaker);
  }
}
